
import { Vue, Component, Prop } from "vue-property-decorator";

import storage from "@/services/storage";
import CrossIcon from "@/components/icons/CrossIcon.vue";

@Component({
  components: {
    CrossIcon,
  }
})
export default class FormImageUploadPreview extends Vue {
  @Prop({type: String, required: true}) readonly s3FileKey!: string;
  @Prop({type: String, default: undefined}) fileUrl?: string;

  filepath: null | string = null;

  async mounted(): Promise<void> {
    if (!this.fileUrl) {
      this.filepath = await this._getFile();
    }
  }

  async updated(): Promise<void> {
    if (!this.fileUrl) {
      this.filepath = await this._getFile();
    }
  }

  get imageLink(): string {
    if (this.fileUrl) {
      return this.fileUrl;
    }
    return this.filepath!;
  }

  async remove(): Promise<void> {
    await this._removeFile();
    this.$emit("remove", this.s3FileKey);
  }

  async _removeFile(): Promise<void> {
    await storage.delete(this.s3FileKey);
  }

  async _getFile(): Promise<string> {
    return await storage.get(this.s3FileKey);
  }
}
